import React, { useState } from 'react';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import { Popover, Fade, ClickAwayListener, List, ListItem, ListItemText } from '@material-ui/core';
import Popup from '../../Modal/PopUp';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import EditHolder from '../../AddHolders/EditHolder';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { deleteHolderFirm, addHolderPremium } from '../../../store/actions/UserAction';
import Snackbar from '../../Snackbar';
import './HolderAdded.scss';
import PopUpTitular from '../../Modal/PopUpTitular';
import axios from 'axios';

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    marginBottom: 16,
    borderRadius: 4,
    backgroundColor: 'white',
    border: '1px solid #e7e7e7',
    marginTop: 8,
    padding: 0,
    '&$expanded': {
      '&:first-child': {
        marginTop: 24,
      },
    },
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    padding: 0,
    minHeight: 56,
    position: 'relative',
  },
  content: {
    margin: 0,
    width: '100%',
    padding: 24,
    '@media screen and (max-width:768.98px)': {
      height: 160,
    },
    '@media (max-width: 425px)': {
      padding: 16,
    },
    '&$expanded': {
      margin: 0,
      padding: '32px 24px 16px',
    },
  },
  expandIcon: {
    color: '#6ecc47',
    alignSelf: 'flex-start',
    position: 'absolute',
    right: 16,
  },
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    display: 'block',
    padding: '0 16px 24px 24px',
  },
})(MuiExpansionPanelDetails);

const useStyles = makeStyles({
  popper: {
    width: 216,
    margin: '0 24px 0 0',
    boxShadow: isMobile ? 'initial' : '0 2px 5px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: isMobile ? 'initial' : '#f5f5f5',
  },
  list: {
    width: 216,
    backgroundColor: 'white'
  },
  listItem: {
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  listItemText: {
    color: '#484848',
    fontSize: 14,
  }
})


function HolderAdded({ 
  nElem,
  uid,
  officeName,
  membershipType,
  allHolders,
  deleteHolderFirm,
  elements,
  preview,
  handleSnack,
  alreadyRewarded,
  handleRewarded,
  addHolderPremium,
  handleTrophieModalOpen,
  credentialsLawyer
}) {
  const [flagEdit, setFlagEdit] = useState(0);

  const FnEditHolder = () => {
    setFlagEdit(1)
    setAnchorEl(null)
  };

  const changeStatus = (isActive) => {
    setFlagEdit(0);
  };

  const [ openExpand, setOpenExpand ] = useState(false)
  const [ openInfo, setOpenInfo ] = useState(false)
  const [ openMark, setOpenMark ] = useState(false)

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'info'
  });

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'info'
    });
  };

  const handleOpenInfo = () => {
    setOpenInfo(true)
  }
  const handleCloseInfo = () => {
    setOpenInfo(false)
  }

  const handleOpenExpand = () => {
    setOpenExpand(true)
  }
  const handleCloseExpand = () => {
    setOpenExpand(false)
  }

  const handleOpenMark= () => {
    setOpenInfo(false)
    setOpenMark(true)
  }
  const handleCloseMark = () => {
    setOpenMark(false)
  }
  const handleAcceptMark = () => {
    let resInfo ="Datos actualizados con éxito";
    let resStatus = "success";
 

    var data = JSON.stringify(
      {"termsAndConditions":true,"genero":elements.gender,"role":"lawyer","secondLastName":elements.secondLastName ? elements.secondLastName : '',
      "cedula": elements.cedula ? elements.cedula : '', "gradeStudy": elements.gradeStudy? elements.gradeStudy :'',
    "firstLastName":elements.firstLastname,"name":elements.nameHolder,"email":elements.email,
    "coursesLawyer" : elements.courses ? elements.courses : [], "languages": elements.holderLanguages? elements.holderLanguages : '',
    "certificationsLawyer": elements.certifications? elements.certifications : [],
    "educationLawyer":elements.educationHolder ? elements.educationHolder : [],
    "laboralsLawyer":elements.laboralHolder? elements.laboralHolder : [],
    "publicationsLawyer":elements.publications ? elements.publications : [],
    "awardsLawyer":elements.awards ? elements.awards : [],
    "imgProfile":elements.imgProfileHolder ?elements.imgProfileHolder : '',
    "specialties":elements.specialties ,"idLawFirm": uid, nameFirm: officeName });


 var config = {
      method: 'post',
      url: 'https://us-central1-contactaabogado-a1be9.cloudfunctions.net/contactaBackend/lawyers/create_lawyer_user_firm',
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    axios(config)
    .then(function (response) {
      console.log(response.data);
      if(response.data.status == "error"){
          console.log(response.data.status)
          switch (response.data.menssage) {
            case "The email address is already in use by another account.":
              resInfo = "El email ya esta en uso";
              resStatus = "error"
              console.log("entro")
              break;
          
            default:
              resInfo = "Error en la creación";
              resStatus = "error"
              break;
          }
          setOpenMark(false)
          setFeedbackMessage({
            open: true,
            message: resInfo,
            variant: resStatus
          });


      }else{
        addHolderPremium(uid, nElem, allHolders, elements.email, response.data)

        setOpenMark(false)
        setFeedbackMessage({
          open: true,
          message: resInfo,
          variant: resStatus
        });
        setAnchorEl(null)
      }
    })
    .catch(function (error) {
      setOpenMark(false)
      setFeedbackMessage({
        open: true,
        message: "Error en la creación",
        variant: "error"
      });
    });  
  }




  const tituloNombre = (auth) => {
    switch (auth.gradeStudy) {
      case 'Licenciatura': {
        return 'Lic.';
      }
      case 'Maestría': {
        if (auth.gender == 'male') {
          return 'Mtro.';
        } else if (auth.gender == 'female') {
          return 'Mtra.';
        }
        return '';
      }
      case 'Especialidad':
        return 'Esp.';
      case 'Doctorado': {
        if (auth.gender == 'male') {
          return 'Dr.';
        } else if (auth.gender == 'female') {
          return 'Dra.';
        }
        return ''
      }
      default:
        return '';
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopper = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const [ outsideOpen, setOutsideOpen ] = useState(false)

  const handleOutside = () => {
    setOutsideOpen(!outsideOpen)
  }

  const confirmDeleteHolder = event => {
    event.preventDefault()
    setOutsideOpen(false)
    deleteHolderFirm(uid, nElem, allHolders).then(res => {
      handleSnack()
    });
    handleSnack()
  };

  const someObjectInArray = (array) => {
    const allValues = Object.values(array[0])
    const evaluation = allValues.some(elem => {
      if (elem) {
        return true
      }
      return false
    })
    return evaluation;
  }

  const openPopper = Boolean(anchorEl);
  const idPopper = openPopper ? 'transitions-popper' : undefined;
  const classes = useStyles()
  return (
    <>
      <Popup
        open={outsideOpen}
        handleClose={handleOutside}
        title={['Seguro que deseas eliminar a', <br />, `${elements.nameHolder} ${elements.firstLastname} ${elements.secondLastName}?`]}
        subtitle={`Si eliminas a ${elements.nameHolder} ${elements.firstLastname} ${elements.secondLastName} se borrará de tu lista de miembros del equipo, para regresar presiona el botón Cancelar `}
        primaryButton={true}
        primaryButtonVariant='primarySolidOutlined'
        primaryButtonText='Sí, eliminar'
        primaryFunction={confirmDeleteHolder}
        secondaryButton={true}
        secondaryOptionalFunctionForCancel={() => setAnchorEl(null)}
        secondaryButtonVariant='primary'
      />

<PopUpTitular
        open={openInfo}
        handleClose={handleCloseInfo}
        title={['Información insuficiente']}
        subtitle={`Es necesario que la "información del despacho" y que los "datos del abogado titular" estén correctamente llenos. De no contar con información en algún campo, tendrás que proceder a llenarlo manualmente.`}
        primaryButton={true}
        primaryButtonVariant='primarySolidOutlined'
        primaryButtonText='Sí, continuar'
        primaryFunction={handleOpenMark}
        secondaryButton={true}
        secondaryOptionalFunctionForCancel={() => setAnchorEl(null)}
        secondaryButtonVariant='primary'
      />


<PopUpTitular
        open={openMark}
        handleClose={handleCloseMark}
        title={[`¿Deseas marcar a ${elements.nameHolder} ${elements.firstLastname} ${elements.secondLastName} como abogado Premium?`]}
        subtitle={[`Al marcarlo como Premium se generará un nuevo pefil para el titular y éste se mostrará en los listados de abogados independientes en nuestra plataforma. 
        `, <br />, <br />,  `
        El abogado solo puede ser seleccionado una vez, por lo tanto no puedes cambiar de abogado titular, ¿Deseas utilizar el beneficio de Abogado Premium Cortesía con el ${elements.nameHolder} ${elements.firstLastname} ${elements.secondLastName}?`]}
        primaryButton={true}
        primaryButtonVariant='primarySolidOutlined'
        primaryButtonText='Sí, continuar'
        primaryFunction={handleAcceptMark}
        secondaryButton={true}
        secondaryOptionalFunctionForCancel={() => setAnchorEl(null)}
        secondaryButtonVariant='primary'
      />

<Snackbar
          open={feedbackMessage.open}
          message={feedbackMessage.message}
          variant={feedbackMessage.variant}
          handleClose={handleCloseFeedbackMessage}
          vertical="top"
          horizontal="right"
          snackbarTop={isMobile ? '8px' : '80px'}
        />
      <div style={{ width: '100%' }}>
        {elements && flagEdit === 0 ? (
        <ExpansionPanel
          expanded={openExpand}
        >
          <ExpansionPanelSummary>
            <img
              className="cardAsociaHolder_flag"
              // src={elements.lawyerPremium ? ("/img/expand/blue-flag.svg") : ("/img/expand/yellow-flag.svg")}
              src="/img/expand/yellow-flag.svg"
              alt="flag"
            />
            <section className="cardAsociaHolder">
              {preview && preview ? ('') : (
                  <img
                    className="cardAsociaHolder_edit"
                    src="/img/expand/menu-options.svg"
                    alt="editar" 
                    onClick={handlePopper}
                  />
                )
              }
              <Popover
                open={openPopper}
                anchorEl={anchorEl}
                className={classes.popper}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                  vertical: 'center',
                  horizontal: 'right',
                }}
              >
                <List className={classes.list} component="nav" aria-label="secondary mailbox folders">
                  <ListItem
                    className={classes.listItem}
                    button
                  >
                    <ListItemText onClick={FnEditHolder} className={classes.listItemText} primary="Editar" />
                  </ListItem>
                  {credentialsLawyer && credentialsLawyer.email == elements.email ? (''): ( <ListItem
                    className={classes.listItem}
                    button
                  >
                    <ListItemText onClick={handleOutside} className={classes.listItemText} primary="Eliminar" />
                  </ListItem>)
                  }
                  {membershipType == 'Premium' && !credentialsLawyer ? ( <ListItem
                    className={classes.listItem}
                    button
                  >
                    <ListItemText onClick={handleOpenInfo} className={classes.listItemText} primary="Elegir como abogado premium" />
                  </ListItem> ): ''}
                  
                </List>                
              </Popover>
              <header className="cardAsociaHolder_header">
                <figure className="cardAsociaHolder_header_avatar">
                  <img
                    className="cardAsociaHolder_header_avatar_imgElement"
                    src={elements.imgProfileHolder ? elements.imgProfileHolder : "/img/avatars/avatares-cuadro-h.svg"}
                    alt={`${elements.nameHolder} ${elements.firstLastname}`}
                  />
                </figure>
                <div className="cardAsociaHolder_header_title">
                  <p className="cardAsociaHolder_header_title_name">
                    {`${tituloNombre(elements)} ${elements.nameHolder} ${elements.firstLastname} ${elements.secondLastName}`}
                  </p>
                  {elements.specialties ?
                    <p className="cardAsociaHolder_header_title_text">
                      {elements.specialties[0]}
                    </p>
                    :
                    ""
                  }
                  {
                    elements.lawyerPremium ? <p className="cardAsociaHolder_header_title_premium">
                      Abogado Premium
                    </p>:""
                  } 
                </div>
              </header>
              <div className="cardAsociaHolder_expandMoreContainer">
                {!openExpand ?
                  <div
                    onClick={handleOpenExpand}
                    className="cardAsociaHolder_expandMore"
                  >
                    <p className="cardAsociaHolder_expandMore-paragraph">Ver más</p>
                    <img src="/img/expand/drop-down.svg" alt="Ver más" />
                  </div> :
                  null
                }
              </div>
            </section>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <section className="cardAsociaHolder">
              <div className="cardAsociaHolder_info">
                <p className="cardAsociaHolder_info_title">Datos personales del titular</p>
                {elements && elements.specialties &&
                  <div className="cardAsociaHolder_data">
                    <div className="cardAsociaHolder_data_field">

                      {elements && elements.gender &&
                        <div className="cardAsociaHolder_dataContainer">
                          <p className="cardAsociaHolder_data_field_title">Género</p>
                          <div className="cardAsociaHolder_data_field_text">
                            <p>
                              {elements.gender === 'male' ?
                                'Masculino' :
                                'Femenino'
                              }
                            </p>
                          </div>
                        </div>
                      }

                      {elements && elements.gradeStudy &&
                        <div className="cardAsociaHolder_dataContainer">
                          <p className="cardAsociaHolder_data_field_title">Último grado de estudios</p>
                          <div className="cardAsociaHolder_data_field_text">
                            <p>{elements.gradeStudy}</p>
                          </div>
                        </div>
                      }

                      {elements && elements.cedula &&
                        <div className="cardAsociaHolder_dataContainer">
                          <p className="cardAsociaHolder_data_field_title">Cédula Profesional</p>
                          <div className="cardAsociaHolder_data_field_text">
                            <p>{elements.cedula}</p>
                          </div>
                        </div>
                      }

                      {elements.specialties && elements.specialties.length === 1 ?
                        <p className="cardAsociaHolder_data_field_title">Especialidad</p> :
                      elements.specialties && elements.specialties.length ?
                        <p className="cardAsociaHolder_data_field_title">Especialidades</p> : null
                      }
                      <div className="cardAsociaHolder_espe">
                        <ul>
                          {elements.specialties && elements.specialties.map((specialty, index) => 
                            <li key={index}>{specialty}</li>
                          )}
                        </ul>
                      </div>

                      {elements && elements.educationHolder && elements.educationHolder.length >= 1 &&
                        <>
                          {someObjectInArray(elements.educationHolder) === true &&
                            <>
                              <p className="cardAsociaHolder_data_field_title2">Educación</p>
                              <div className="cardAsociaHolder_education">
                                <ul>
                                  {elements.educationHolder && elements.educationHolder.map((educationItem, index) => {
                                    const {nameUniversity, receivedGradeStudy, discipline, firstYear, lastYear} = educationItem;

                                    return (
                                      <li key={index}>
                                        <div>
                                          {nameUniversity &&
                                            <p>{nameUniversity}</p>
                                          }
                                          {receivedGradeStudy && discipline &&
                                            <p>{`${receivedGradeStudy}, ${discipline}`}</p>
                                          }
                                          {firstYear && lastYear &&
                                            <p>{firstYear} - {lastYear}</p>
                                          }
                                        </div>
                                      </li>)
                                    }
                                  )}
                                </ul>
                              </div>
                            </>
                          }
                        </>
                      }

                      {elements && elements.courses && elements.courses.length >= 1 &&
                        <>
                          {someObjectInArray(elements.courses) === true &&
                            <>
                              <p className="cardAsociaHolder_data_field_title2">Cursos y diplomados</p>
                              <div className="cardAsociaHolder_education">
                                <ul>
                                  {elements.courses && elements.courses.map((course, index) => {
                                    const {name, place, firstYear, lastYear} = course;
                                    return (
                                      <li key={index}>
                                        <div>
                                          {name &&
                                            <p>{name}</p>
                                          }
                                          {place &&
                                            <p>{place}</p>
                                          }
                                          {firstYear && lastYear &&
                                            <p>{firstYear} - {lastYear}</p>
                                          }
                                        </div>
                                      </li>)
                                    }
                                  )}
                                </ul>
                              </div>
                            </>
                          }
                        </>
                      }

                      {elements && elements.certifications && elements.certifications.length >= 1 &&
                        <>
                          {someObjectInArray(elements.certifications) === true &&
                            <>
                              <p className="cardAsociaHolder_data_field_title2">Certificaciones</p>
                              <div className="cardAsociaHolder_model">
                                <ul>
                                  {elements.certifications && elements.certifications.map((certification, index) => {
                                    const {name, place, year, myImageCert} = certification;
                                    return (
                                      <li key={index}>
                                        {myImageCert &&
                                          <img
                                            src={myImageCert}
                                            alt="certification"
                                            className="cardAsociaHolder_model_photo"
                                          />}
                                        <div>
                                          {name && <p>{name}</p>}
                                          {place && <p>{place}</p>}
                                          {year && <p>{year}</p>}
                                        </div>
                                      </li>)
                                    }
                                  )}
                                </ul>
                              </div>
                            </>
                          }
                        </>
                      }

                      {elements && elements.awards && elements.awards.length >= 1 &&
                        <>
                          {someObjectInArray(elements.awards) === true &&
                            <>
                              <p className="cardAsociaHolder_data_field_title2">Premios y reconocimientos</p>
                              <div className="cardAsociaHolder_model">
                                <ul>
                                  {elements.awards && elements.awards.map((award, index) => {
                                    const {name, place, year, myImageAward} = award;
                                    return (
                                      <li key={index}>
                                        {myImageAward &&
                                          <img
                                            src={myImageAward}
                                            alt="award"
                                            className="cardAsociaHolder_model_photo"
                                          />}
                                        <div></div>
                                        <div>
                                          {name && <p>{name}</p>}
                                          {place && <p>{place}</p>}
                                          {year && <p>{year}</p>}
                                        </div>
                                      </li>)
                                    }
                                  )}
                                </ul>
                              </div>
                            </>
                          }
                        </>
                      }

                      {elements && elements.publications && elements.publications.length >= 1 &&
                        <>
                          {someObjectInArray(elements.publications) === true &&
                            <>
                              <p className="cardAsociaHolder_data_field_title2">Publicaciones</p>
                              <div className="cardAsociaHolder_publication">
                                <ul>
                                  {elements.publications && elements.publications.map((publication, index) => {
                                    const {title, url, year} = publication;
                                    return (
                                      <li key={index}>
                                        <div>
                                          {title && <p>{title}</p>}
                                          {url && <a 
                                                    href={`${url}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer nofollow"
                                                  >
                                                    {url}
                                                  </a>}
                                          {year && <p>{year}</p>}
                                        </div>
                                      </li>)
                                    }
                                  )}
                                </ul>
                              </div>
                            </>
                          }
                        </>
                      }

                      {elements.holderLanguages && elements.holderLanguages.length ?
                        <>
                          <p className="cardAsociaHolder_data_field_title2">Idiomas</p>
                          <div className="cardAsociaHolder_espe">
                            <ul>
                              {elements.holderLanguages && elements.holderLanguages.map((language, index) => 
                                <li key={index}>{language}</li>
                              )}
                            </ul>
                          </div>
                        </> : null
                      }

                      {elements && elements.laboralHolder && elements.laboralHolder.length >= 1 &&
                        <>
                          {someObjectInArray(elements.laboralHolder) === true &&
                            <>
                              <p className="cardAsociaHolder_data_field_title2">Experiencia Laboral</p>
                              <div className="cardAsociaHolder_laboral">
                                <ul>
                                  {elements.laboralHolder && elements.laboralHolder.map((laboralItem, index) => {
                                    const {companyPosition, nameCompany, actualCompanyPosition, firstMonth, firstLaboralYear} = laboralItem;
                                    return (
                                      <li key={index}>
                                        <div>
                                          {companyPosition ?
                                            <p>{companyPosition}</p> :
                                            null
                                          }
                                          {nameCompany ?
                                            <p>{nameCompany}</p> :
                                            null
                                          }
                                          {firstMonth && firstLaboralYear ?
                                            <p>{firstMonth.slice(0, 3)}. de {firstLaboralYear}</p> :
                                          firstMonth && firstLaboralYear && actualCompanyPosition ?
                                            <p>{firstMonth.slice(0, 3)}. de {firstLaboralYear} - Actualidad</p> :
                                            null
                                          }
                                        </div>
                                      </li>)
                                    }
                                  )}
                                </ul>
                              </div>
                            </>
                          }
                        </>
                      }

                      {openExpand &&
                        <div
                          onClick={handleCloseExpand}
                          className='cardAsociaHolder_expandLess'
                        >
                          <p className='cardAsociaHolder_expandLess-paragraph'>Ver menos</p>
                          <img src="/img/expand/drop-up.svg" alt="Ver menos" />
                        </div>
                      }
                    </div>
                  </div>}
              </div>
            </section>
          </ExpansionPanelDetails>
        </ExpansionPanel>)
  : (
      <div>
        <EditHolder
          elements={elements}
          outsideOpen={outsideOpen}
          handleOutside={handleOutside}
          evento={changeStatus}
          setFlagEdit={setFlagEdit}
          item={nElem}
          allHolders={allHolders}
          handleSnack={handleSnack}
          alreadyRewarded={alreadyRewarded}
          handleRewarded={handleRewarded}
          handleTrophieModalOpen={handleTrophieModalOpen}
        />
      </div>
      )
    }
      </div>
    </>
  );
}

const mapDispatchToProps = dispatch => ({
  deleteHolderFirm: (uid, item, allHolders) =>
    dispatch(deleteHolderFirm(uid, item, allHolders)),
    addHolderPremium: (uid, item,email, allHolders, data ) =>
    dispatch(addHolderPremium(uid, item, allHolders,email,data)),
  
})

const mapStateToProps = state => ({
  uid: state.authClient.uid ? state.authClient.uid :  "",
  officeName: state.authClient.officeName? state.authClient.officeName: "",
  membershipType: state.authClient.membership ? state.authClient.membership.type : "",
  credentialsLawyer: state.authClient.credentialsLawyer ? state.authClient.credentialsLawyer : false,
})
export default connect(mapStateToProps, mapDispatchToProps)(HolderAdded);